<template>
  <error-component :error="error" />
</template>

<script setup lang="ts">
import ErrorComponent from '@/modules/error/components/ErrorComponent.vue'
import { StorefrontError } from '@/modules/error/types'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const error: StorefrontError = {
  code: 404,
  message: t('error.pageNotFound')
}
</script>
